// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__9MrVv","row":"Node_row__wwwxj","label":"Node_label__17SW5","footer":"Node_footer__3WGhf"};